module.exports = __webpack_public_path__ + "static/media/UserMangment.313aa21c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/UserMangment.svg
// module id = 1373
// module chunks = 0